import { Dropdown, Icon, Image, Menu, Sticky } from 'semantic-ui-react';
import { connect } from 'react-redux';
import * as actions from '../../redux/actions';
import * as selectors from '../../redux/selectors';
import { getRoutes, getLoginStatus } from '../../redux/selectors';
import { bindActionCreators } from 'redux';
import * as R from 'ramda';

export const Header = ({ logout, navigate, user, routes, contextRef, userMap }: any) => {
  const handleItemClick = (e, { name }) => {
    navigate(`/${name}`);
  };

  const groups = R.filter(R.prop('name'));
  const parentItems = R.pipe(R.prop('items'), R.filter(R.propSatisfies(R.isNil, 'isChild')));
  const hasChildMenuItems = R.pipe(parentItems, R.propSatisfies(R.gt(R.__, 1), 'length'));

  const getMenuItem = (group, idx) => {
    if (hasChildMenuItems(group)) {
      return (
        <Dropdown closeOnChange closeOnBlur labeled key={group.name} simple item text={group.name} direction="left">
          <Dropdown.Menu>
            {parentItems(group).map((item, index) => (
              <Dropdown.Item key={index} name={item.route} onClick={handleItemClick} content={item.title} />
            ))}
          </Dropdown.Menu>
        </Dropdown>
      );
    }
    const item = R.head(parentItems(group));
    return <Menu.Item key={idx} name={item.route} onClick={handleItemClick} content={item.title} />;
  };

  if (window.location.pathname === '/reporting') {
    return <></>;
  }

  return (
    <Sticky context={contextRef}>
      <Menu fluid stackable size="tiny">
        <Menu.Item header id="home-logo" name="home" onClick={handleItemClick}>
          <Image src="/static/favicon.png" size="mini" style={{ marginRight: '5px', height: 30, width: 30 }} />
        </Menu.Item>

        {groups(routes).map(getMenuItem)}

        <Menu.Menu position="right">
          <Menu.Item style={{ minWidth: 60 }}>
            {/* <ClipLoader color="#CC4857" size={25} loading={loading} /> */}
          </Menu.Item>
          <Dropdown
            item
            size="tiny"
            className="icon"
            data-cy="user-header-menu"
            icon={userMap[user.id]?.imageUrl ? <Image avatar src={userMap[user.id]?.imageUrl} /> : <Icon name="user" />}
          >
            <Dropdown.Menu>
              <Dropdown.Item icon="user circle outline" text={'My profile'} onClick={() => navigate('/profile')} />
              <Dropdown.Item
                id="logout"
                data-cy="logout"
                name="user-logout"
                icon="log out"
                onClick={logout}
                text="Logout"
              />
            </Dropdown.Menu>
          </Dropdown>
        </Menu.Menu>
      </Menu>
    </Sticky>
  );
};

const mapStateToProps = state => ({
  user: selectors.users.current(state),
  loggedIn: getLoginStatus(state),
  routes: getRoutes(state),
  loading: state.user.loading,
  userMap: selectors.admin.userMap(state),
});

const mapDispatchToProps = dispatch => ({
  logout: bindActionCreators(actions.user.logout, dispatch),
  navigate: bindActionCreators(actions.user.navigate, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
